/*eslint-disable*/
import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback
} from 'react'
import { useParams } from 'react-router-dom'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import CompanyInformation from './CompanyInformation'
import EmployeesWidget from '../Assignments/EmployeesWidget'
import DetailComponent from './CompanyDetailComponent'
import ContractTable from '../../ContractDashboard/ContractTable'
import ScaleTicketsTable from '../../ContractDashboard/ScaleTicketsTable'
import Toast from '../../../components/subComponents/Notifications/Toast'
import Alert from '../../../components/subComponents/Notifications/Alert'
import { Button } from 'syngenta-react-components'
import NewCompanyForm from '../../../components/ModalForms/NewCompanyForm'
import { Modal } from 'syngenta-react-components'
import { NewUserForm } from '../../../components/ModalForms'
import _ from 'lodash'
import { GlobalContext, AuthContext } from '../../../services/context'
import {
  createOrUpdateCompany,
  getAssignments,
  getCompany,
  patchCompany,
  getCompanyContracts,
  getLinkCompanies,
  getScaleTickets,
  getSalesYear,
  getHighestRole,
  syncCompany,
  getCompanyContractsByYear
} from '../../../services/apiHelper'
import useApiHelper from '../../../services/useApiHelper'
import { customSort, getMonthYearFromISO } from '../../../services/utils'
import ProductionPlansWidget from './ProductionPlansWidget'
import LinkedContactsWidget from '../Assignments/LinkedContactsWidget'
import LinkedCompanies from './LinkedCompanies'
import ViewProdPlanDeliveryWidget from '../ProductionPlan/ViewProdPlanDeliveryWidget'
import moment from 'moment'


const CompanyDetailView = props => {
  const canceled = useRef(false)
  const { state, dispatch, trackEvent } = useContext(GlobalContext)
  const { hasAccess } = useContext(AuthContext)
  const { company_id } = useParams()
  const [employeeData, setEmployeeData] = useState(null)
  const [detailData, setDetailData] = useState([])
  const [companyInfo, setCompanyInfo] = useState()
  const [showModal, setShowModal] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [modalState, setModalState] = useState('none')
  const [companyData, setCompanyData] = useState(null)
  const [contractStatus, setContractStatus] = useState('LOADING')
  const [employeeStatus, setEmployeeStatus] = useState('LOADING')
  const [linkedContactsStatus, setlinkedContactsStatus] = useState('LOADING')
  const [linkedContactsData, setLinkedContactsData] = useState(null)
  const [showCreateContract, setShowCreateContract] = useState(false)
  const [modalType, setModalType] = useState()
  const [SAPId, setSAPId] = useState()
  const [linkCompanyData, setLinkCompanyData] = useState(null)
  const [linkCompanyStatus, setLinkCompanyStatus] = useState('LOADING')
  const [modalStatus, setModalStatus] = useState()
  const contract_limit = 1000
  const contract_data_limit = 100
  const [scaleTicketsStatus, setScaleTicketsStatus] = useState('LOADING')
  const [scaleTicketsData, setScaleTicketsData] = useState([])
  const [scaleTicketsYear, setScaleTicketsYear] = useState(
    new Date().getFullYear().toString()
  )
  const [
    scaleTicketSpecificProdPlan,
    setScaleTicketSpecificProdPlan
  ] = useState(null)
  const [scaleTicketReceived, setScaleTicketReceived] = useState([])
  const [sortOrder, setSortOrder] = useState('asc')
  const [sortByKey, setSortByKey] = useState()
  const [contractYear, setContractYear] = useState(
    new Date().getFullYear().toString()
  )
  const [filterContractData, setFilterContractData] = useState([])
  const [productionPlanYear, setProductionPlanYear] = useState(
    new Date().getFullYear().toString()
  )
  const [fetchScaleTickets, setFetchScaleTickets] = useState(false)
  const [totalReceived, setTotalReceived] = useState(null)
  const [monthlyUnits, setMonthlyUnits] = useState()
  const [deliveryStatus, setDeliveryStatus] = useState('LOADING')
  const [
    { data: prodPlanData, status: prodPlanStatus },
    getProductionPlan
  ] = useApiHelper('getProductionPlan')
  const [
    { data: childrenProdPlansData, status: childrenProdPlansStatus },
    getChildrenProductionPlans
  ] = useApiHelper('getProductionPlan')
  const [
    { data: committedUnitsData, status: committedUnitsStatus },
    getCommittedUnits
  ] = useApiHelper('getCommittedUnits')
  const [yearSpecificProdPlan, setYearSpecificProdPlan] = useState()
  const[statusArr, setStatusArr] = useState(['pending','pendinggrowersigned','amendment_pending','amendmentpendinggrowersigned','completed','amendment_completed'])
  const[aphvalue, setAphValue] = useState()
  const [isSyncCompany, setIsSyncCompany] = useState(false)
  const [synBtnTxt, setSynBtnTxt] = useState('Sync company')
  const [allContractData, setAllContractData] = useState([])
  const [contractDataOffset, setContractDataOffset] = useState(null)
  const [isLoadExtraData, setIsLoadExtraData] = useState(false)

  useEffect(() => {
    const init = async () => {
      getProductionPlan(company_id, 'company_id', true)
      await getSalesYear().then(sales_year => {
        setContractYear(sales_year.data.sales_year)
        setProductionPlanYear(sales_year.data.sales_year)
        setScaleTicketsYear(sales_year.data.sales_year - 1)
      })
    }
    if (company_id) {
      init()
    }
  }, [company_id, getProductionPlan])

  useEffect(() => {
    if (prodPlanData) {
      const filteredProdPlan = prodPlanData.find(
        plan => plan.contract_year.toString() === productionPlanYear.toString()
      )
      const filteredScaleTicket = prodPlanData.find(
        plan => plan.contract_year.toString() === scaleTicketsYear.toString()
      )
      setYearSpecificProdPlan(filteredProdPlan)
      setScaleTicketSpecificProdPlan(filteredScaleTicket)
    }
  }, [prodPlanData, productionPlanYear, scaleTicketsYear])

  useEffect(() => {
    const init = async () => {
      getCommittedUnits(yearSpecificProdPlan.production_plan_id)
      getChildrenProductionPlans(
        yearSpecificProdPlan.production_plan_id,
        'parent'
      )
    }
    if (yearSpecificProdPlan) {
      init()
    }
  }, [getChildrenProductionPlans, getCommittedUnits, yearSpecificProdPlan])

  useEffect(() => {
    if (prodPlanData && scaleTicketSpecificProdPlan?.production_plan_id) {
      getScaleTickets(scaleTicketSpecificProdPlan?.production_plan_id, null, 10).then(scaleTickets => {
        if (scaleTickets?.length) {
          setScaleTicketsStatus()
          let filterOutZeroOut = scaleTickets.filter(ticket => !ticket.scale_ticket_id.includes('zeroout'))
          let foundScaleTicketReceived = filterOutZeroOut.map(obj => {
            let returnObj = {}
            if (typeof obj.scale_ticket_date === 'string') {
              returnObj = getMonthYearFromISO(obj.scale_ticket_date)
            }
            if (obj.net_quantity) {
              returnObj.net_quantity = parseFloat(obj.net_quantity.replace(/,/g, ''))
            } else {
              returnObj.net_quantity = 0
            }
            return returnObj
          })
          setScaleTicketReceived(foundScaleTicketReceived)
          setScaleTicketsData(filterOutZeroOut)
        } else {
          setScaleTicketsStatus('EMPTY')
        }
      })
    } else {
      setScaleTicketsStatus('EMPTY')
    }

  }, [scaleTicketSpecificProdPlan, prodPlanData, fetchScaleTickets])


  useEffect(() => {
    getHighestRole()?.then(res => {
      if(res.permissions.includes('sync-company')){
        setIsSyncCompany(true)
      } else{
        setIsSyncCompany(false)
      }
    })
  }, [])

  const handleSyncCompany = () => {
    const params = {
      sapIds: [companyInfo?.sap_id]
    }
    setSynBtnTxt('Sync in progress...')
    syncCompany(params).then(res => {
      if (res.status === 200) {
        setTimeout(()=> {
          setSynBtnTxt('Sync Complete')
          getCompany(company_id)?.then(obj => {
            if (!canceled.current) {
              if (obj) {
                const dispatchObj = {
                  type: 'SET_DETAIL_VIEW',
                  payload: { title: obj.company_name, previous: 'Back' }
                }
                dispatch(dispatchObj)
                setCompanyData(obj)
                setCompanyInfo(parseCompanyData(obj))
                if (obj && obj.details) {
                  if (
                    obj.company_type !== 'grain-receiver' &&
                    obj.company_type !== '3PO' &&
                    obj.company_type !== 'syngenta'
                  ) {
                    setSAPId(obj.sap_id)
                  }
                  setDetailData(obj.details)
                }
              } else {
                dispatch({ type: 'GO_TO_404' })
              }
            }
          })
        },60000)
      }
      else {
        setSynBtnTxt('Sync Failed')
      }
    })
  }

  const generateMonthMap = (year, deliveryType) => {
    const startDate = year
      ? `${year}-09-01`
      : new Date().getFullYear() + '-09-01'
    const momentDate = moment(startDate)
    const monthMap = new Map()
    for (let i = 0;i < 13;i++) {
      const newDate = momentDate.clone().add(i, 'month')
      const delivery_month = newDate.format('MMM-YY')
      const month = newDate.format('MMMM').toLowerCase()
      const year = newDate.format('YYYY')
      monthMap.set(delivery_month, {
        delivery_month,
        month,
        year,
        available_acres: 0,
        available_units: 0,
        contract_acres: 0,
        contract_units: 0,
        delivery_type: deliveryType,
        harvest_bushels: 0,
        premium: 0
      })
    }
    return monthMap
  }

  useEffect(() => {
    setDeliveryStatus('LOADING')
    setTotalReceived(null)
    const formatUnits = (
      contractYear,
      prodPlanMonthlyUnits,
      aph,
      premium_type,
      committedUnits = [],
      childrenProdPlansData
    ) => {
      const deliveryTypes = ['grain', 'silage', 'earlage', 'high-moisture']
      const workingObj = {}
      let allChildMonthlyUnits = []
      if (childrenProdPlansData?.length) {
        childrenProdPlansData.forEach(childProdPlan => {
          allChildMonthlyUnits = [
            ...allChildMonthlyUnits,
            ...childProdPlan.monthly_units
          ]
        })
      }
      deliveryTypes.forEach(deliveryType => {
        const filteredCommittedUnits = committedUnits.filter(comUnit => {
          return comUnit.delivery_type === deliveryType
        })
        const committedUnitsMap = generateMonthMap(contractYear, deliveryType)
        if (filteredCommittedUnits.length) {
          filteredCommittedUnits.forEach(comUnit => {
            let YearExtend = false
            let contractYearNext = parseInt(contractYear) + 1
            if((comUnit.delivery_year < contractYear) || (comUnit.delivery_year > contractYearNext)){
              YearExtend = true
            } else {
              if(comUnit.delivery_year === contractYear && (comUnit.delivery_month.charAt(0)!=='s' || comUnit.delivery_month.charAt(0)!=='o' || comUnit.delivery_month.charAt(0)!=='n' || comUnit.delivery_month.charAt(0)!=='d')){
                YearExtend = true
              }
              if(comUnit.delivery_year === contractYearNext &&  (comUnit.delivery_month.charAt(0)==='o' || comUnit.delivery_month.charAt(0)==='n' || comUnit.delivery_month.charAt(0)==='d')){
                YearExtend = true
              }
            }
            if(YearExtend === true) {
              if(comUnit.delivery_month.charAt(0)==='s' || comUnit.delivery_month.charAt(0)==='o' || comUnit.delivery_month.charAt(0)==='n' || comUnit.delivery_month.charAt(0)==='d')
                comUnit.delivery_year = contractYear
              else
                comUnit.delivery_year = contractYearNext
            }
            const delivery_month = moment(
              `${comUnit.delivery_month}, 1 ${comUnit.delivery_year}`
            ).format('MMM-YY')
            const current = committedUnitsMap.get(delivery_month)
            if (current) {
              const totalContractedUnits =
                parseInt(current.contract_units) +
                parseInt(comUnit.contract_units)
              const totalContractedAcres = parseInt(current.contract_acres) +
              parseInt(comUnit.contract_acres)
              const totalHarvestBushels =
                parseInt(current.harvest_bushels) +
                parseInt(comUnit.harvest_bushels)
              const returnable = {
                ...current,
                contract_acres: totalContractedAcres,
                contract_units: totalContractedUnits,
                harvest_bushels: totalHarvestBushels
              }
              committedUnitsMap.set(delivery_month, returnable)
            } else {
              committedUnitsMap.set(delivery_month, comUnit)
            }
          })
        }
        workingObj[deliveryType] = committedUnitsMap
      })

      if (prodPlanMonthlyUnits.length) {
        deliveryTypes.forEach(deliveryType => {
          const filteredUnits = prodPlanMonthlyUnits.filter(comUnit => {
            return comUnit.end_product_type === deliveryType
          })
          const filteredChildUnits = allChildMonthlyUnits.filter(
            monthlyUnits => {
              return monthlyUnits.end_product_type === deliveryType
            }
          )
          const committedUnitsMap = workingObj[deliveryType]
          if (filteredUnits.length) {
            filteredUnits.forEach(comUnit => {
              const delivery_month = moment(
                `${comUnit.month}, 1 ${comUnit.year}`
              ).format('MMM-YY')
              const current = committedUnitsMap.get(delivery_month)
              const premiumType = premium_type === 'bushels' ? 'bu' : 'ac'
              const returnable = {
                ...current,
                premium: parseFloat(comUnit.premium).toFixed(2)+'/'+premiumType,
                available_acres:
                  comUnit.available_acres - current.contract_acres,
                available_units:
                  comUnit.available_units - current.contract_units,
                total_acres: comUnit.available_acres,
                total_units: comUnit.available_units
              }
              committedUnitsMap.set(delivery_month, returnable)
            })
          }
          // eslint-disable-next-line no-constant-condition
          if (filteredChildUnits.length && false) {
            filteredChildUnits.forEach(monthlyUnit => {
              const delivery_month = moment(
                `${monthlyUnit.month}, 1 ${monthlyUnit.year}`
              ).format('MMM-YY')
              const current = committedUnitsMap.get(delivery_month)
              if (current) {

                const totalContractedUnits =
                  current.contract_units + parseInt(monthlyUnit.child_plan_units)
                const totalContractedAcres = current.contract_acres +
                  parseInt(monthlyUnit.child_plan_acres)

                const totalAvailableAcres =
                  current.total_acres - totalContractedAcres
                const totalAvailableUnits =
                  parseInt(current.total_units) -
                  parseInt(totalContractedUnits)

                const returnable = {
                  ...current,
                  available_acres: totalAvailableAcres,
                  available_units: totalAvailableUnits,
                  contract_acres: totalContractedAcres,
                  contract_units: totalContractedUnits
                }

                committedUnitsMap.set(delivery_month, returnable)
              } else {
                committedUnitsMap.set(delivery_month, {
                  ...current
                })
              }
            })
          }
        })
      }

      const returnObj = {}
      deliveryTypes.forEach(deliveryType => {
        let typeArray = []
        const currentMap = workingObj[deliveryType]
        currentMap.forEach(comUnit => {
          typeArray.push(comUnit)
        })
        typeArray = typeArray.map(obj => {
          const totalAcres = parseFloat(obj.total_acres) || 0
          const totalUnits = parseFloat(obj.total_units) || 0

          const availableAcres = totalAcres - obj.contract_acres
          const availableUnits = totalUnits - obj.contract_units

          return {
            ...obj,
            available_acres: availableAcres,
            available_units: availableUnits
          }
        })
        returnObj[deliveryType] = typeArray
      })
      return returnObj
    }
    if (
      (!committedUnitsStatus || committedUnitsStatus === 'EMPTY') &&
      (!childrenProdPlansStatus || childrenProdPlansStatus === 'EMPTY') &&
      yearSpecificProdPlan?.monthly_units
    ) {
      setAphValue(yearSpecificProdPlan.aph)
      const returnable = formatUnits(
        yearSpecificProdPlan.contract_year,
        yearSpecificProdPlan.monthly_units,
        yearSpecificProdPlan.aph,
        yearSpecificProdPlan.premium_type,
        committedUnitsData,
        childrenProdPlansData
      )
      returnable.contract_year = yearSpecificProdPlan.contract_year


      if(returnable) {
        let totalNetQtyMap = 0
        if (prodPlanData && yearSpecificProdPlan) {
          const productionplanVal = prodPlanData.find(plan => {
            return yearSpecificProdPlan.contract_year === plan.contract_year
          })?.production_plan_id
          getScaleTickets(productionplanVal, null).then(scaleTickets => {
            let totalNetQty = 0
            if (scaleTickets.length) {
              scaleTickets.forEach(ticket => {
                let selectedNetQty = 0
                if (ticket.net_quantity && typeof ticket.net_quantity === 'string') {
                  selectedNetQty = parseFloat(ticket.net_quantity.replace(/,/g, ''))
                }
                if (ticket.net_quantity && typeof ticket.net_quantity === 'number') {
                  selectedNetQty = ticket.net_quantity
                }
                totalNetQty = totalNetQty + selectedNetQty
              })
            }
            totalNetQtyMap = totalNetQty
          }).then(() => {
            setDeliveryStatus()
            setTotalReceived(totalNetQtyMap)
            setMonthlyUnits(returnable)
          })
        }
      }
    } else if ((committedUnitsStatus === 'EMPTY' || !committedUnitsStatus) && (!childrenProdPlansData || !childrenProdPlansData.length )) {
      setDeliveryStatus('EMPTY')
    } else {
      setDeliveryStatus('LOADING')
    }
  }, [
    childrenProdPlansData,
    childrenProdPlansStatus,
    committedUnitsData,
    committedUnitsStatus,
    prodPlanStatus,
    scaleTicketReceived,
    yearSpecificProdPlan,
    prodPlanData
  ])

  const parseCompanyData = obj => {
    return _.pick(obj, [
      'country',
      'address1',
      'city',
      'state',
      'zipcode',
      'phone',
      'company_type',
      'formatedPhone',
      'sap_id',
      'inventory_code',
      'enogen_dealer',
      'allow_non_enogen_contracts'
    ])
  }

  const _getAssignments = async () => {
    return getAssignments(company_id)?.then(obj => {
      if (!canceled.current) {
        const employeeData = obj.filter(
          assignment => assignment.role_type === 'external'
        )
        const linkedContactsData = obj.filter(
          assignment => assignment.role_type === 'internal'
        )
        setEmployeeData(employeeData)
        setLinkedContactsData(linkedContactsData)
        setEmployeeStatus(null)
        setlinkedContactsStatus(null)
      }
    })
  }

  const _getLinkCompanies = useCallback(async company_id => {
    setLinkCompanyStatus('LOADING')
    getLinkCompanies(company_id)?.then(result => {
      if (!canceled.current) {
        if (result && result.length && company_id) {
          setLinkCompanyStatus()
        } else {
          setLinkCompanyStatus('EMPTY')
        }
        setLinkCompanyData(result)
      }
    })
  }, [])

  useEffect(() => {
    if (!canceled.current && state.detailView?.details) {
      setDetailData(state.detailView.details)
    }
  }, [state.detailView])

  useEffect(() => {
    const initData = () => {
      setEmployeeStatus('LOADING')
      setlinkedContactsStatus('LOADING')
      getCompany(company_id)?.then(obj => {
        if (!canceled.current) {
          if (obj) {
            const dispatchObj = {
              type: 'SET_DETAIL_VIEW',
              payload: { title: obj.company_name, previous: 'Back' }
            }
            dispatch(dispatchObj)
            setCompanyData(obj)
            setCompanyInfo(parseCompanyData(obj))
            if (obj && obj.details) {
              if (
                obj.company_type !== 'grain-receiver' &&
                obj.company_type !== '3PO' &&
                obj.company_type !== 'syngenta'
              ) {
                setSAPId(obj.sap_id)
              }
              setDetailData(obj.details)
            }
          } else {
            dispatch({ type: 'GO_TO_404' })
          }
        }
      })
      getAssignments(company_id)?.then(arr => {
        if (!canceled.current) {
          if (arr && arr.length) {
            setEmployeeStatus(null)
            setlinkedContactsStatus(null)
            const employeeData = arr.filter(
              assignment => assignment.role_type === 'external'
            )
            const linkedContactsData = arr.filter(
              assignment => assignment.role_type === 'internal'
            )
            setEmployeeData(employeeData)
            setLinkedContactsData(linkedContactsData)
          } else {
            setEmployeeStatus('EMPTY')
            setlinkedContactsStatus('EMPTY')
          }
        }
      })
      _getLinkCompanies(company_id)
    }
    initData()
    return () => {
      canceled.current = true
    }
  }, [company_id, _getLinkCompanies, dispatch])

  useEffect(() => {
    if (allContractData && allContractData.length) {
      let result = customSort(allContractData, sortByKey, sortOrder).filter(
        obj => obj.contract_year === contractYear.toString()
      )
      if (result.length && statusArr.length) {
        const filteredArr = result.filter(el => {
          return statusArr.some(f => {
            return f === el.contract_status
          })
        })
        setFilterContractData(filteredArr)
        setContractStatus()
        if(filteredArr.length === 0){
          setContractStatus('EMPTY')
        }
      } else if(result.length) {
        setContractStatus()
        setFilterContractData(result)
      } else {
        setContractStatus('EMPTY')
      }
    }
  }, [sortByKey, sortOrder, contractYear, statusArr, allContractData])

  useEffect(() => {
    if (hasAccess(company_id, 'create-contract') === 'SUCCESS') {
      setShowCreateContract(false)
    }
  }, [company_id, hasAccess])

  const patchHandler = payload => {
    payload.company_id = company_id
    patchCompany(payload)
      .then(() => { })
      .then(() => {
        getCompany(company_id)?.then(obj => {
          if (!canceled.current) {
            setCompanyData(obj)
            setCompanyInfo(parseCompanyData(obj))
            setDetailData(obj.details)
          }
        })
      })
  }

  const get_company = async () => {
    return getCompany(company_id)?.then(obj => {
      if (!canceled.current) {
        setCompanyData(obj)
        setCompanyInfo(parseCompanyData(obj))
        setDetailData(obj.details)
      }
      return Promise.resolve(obj)
    })
  }

  const handleResellerModal = () => {
    setShowModal(true)
    setModalStatus('')
    setModalState('companyInfo')
    trackEvent('edit_company_information_clicked', { companyId: company_id })
  }

  const handleCompanyDetailsModal = () => {
    setModalState('companyDetails')
    setShowModal(true)
  }

  const handleModalEmployees = () => {
    setShowModal(true)
    setModalState('inviteUser')
    setModalType('employees')
    trackEvent('employees_invite_user_clicked', { companyId: company_id })
  }

  const handleModalLinkedContacts = () => {
    setShowModal(true)
    setModalState('inviteUser')
    setModalType('linkedContacts')
    trackEvent('linked_contacts_invite_user_clicked', { companyId: company_id })
  }

  const closeModal = () => {
    setShowModal(false)
    setModalState('none')
  }

  const handleClose = result => {
    if (result === 'SUCCESS') {
      _getAssignments()
    }
    closeModal()
  }

  const handleDelete = () => {
    getScaleTickets(scaleTicketSpecificProdPlan?.production_plan_id, null, 10).then(scaleTickets => {
      if (scaleTickets?.length) {
        setScaleTicketsStatus()
        const filterOutZeroOut = scaleTickets.filter(ticket => !ticket.scale_ticket_id.includes('zeroout'))
        let firstTenTickets = filterOutZeroOut.slice(0, 10)
        setScaleTicketsData(firstTenTickets)
      } else {
        setScaleTicketsStatus('EMPTY')
      }
    })
  }

  const editCompany = (formValues, company_id) => {
    let country = formValues.country
    let company = formValues.company
    let company_type = formValues.company_type
    let address = formValues.address
    let _state = formValues.state
    let zipcode = formValues.zipcode
    let city = formValues.city
    let address2 = formValues.address2
    let phone = formValues.phone
    let sap_id = formValues.sap_id
    let salesforce_id = formValues.salesforce_id
    let inventory_code = formValues.inventory
    let supportedLang = formValues.supportedLang

    setModalStatus('LOADING')
    createOrUpdateCompany(
      country,
      company,
      company_type,
      address,
      address2,
      city,
      _state,
      zipcode,
      phone,
      true,
      company_id,
      sap_id,
      salesforce_id,
      inventory_code,
      supportedLang
    ).then(response => {
      if (!canceled.current) {
        if (response?.data?.company_id) {
          setModalStatus('SUCCESS')
          // Update companyData
          setCompanyData(response.data)
          setCompanyInfo(parseCompanyData(response.data))
          if (response.data.details) {
            setDetailData(response.data.details)
          }
          const dispatchObj = {
            type: 'SET_DETAIL_VIEW',
            payload: { title: response.data.company_name, previous: 'Back' }
          }
          dispatch(dispatchObj)
        } else {
          setModalStatus('FAILED')
        }
      }
    })
  }

  useEffect(()=> {
    if(company_id ) {
      setAllContractData([])
      setContractStatus('LOADING')
      getCompanyContractsByYear(company_id,contract_data_limit,contractYear,0,statusArr).then(res => {
        if(res.length > 0 ) {
          setAllContractData(res)
          setContractStatus()
          setContractDataOffset(0)
        }else{
          setAllContractData([])
          setContractStatus('EMPTY')
        }
      })
    }
  },[contractYear,companyData,statusArr])

  const renderModal = () => {
    switch (modalState) {
      case 'inviteUser':
        return (
          <NewUserForm
            handleClose={handleClose}
            companyId={company_id}
            modalType={modalType}
          />
        )
      case 'companyInfo':
        return (
          <NewCompanyForm
            modalStatus={modalStatus}
            handleSubmitNewCompanyForm={editCompany}
            handleClose={closeModal}
            companyData={companyData}
            editMode={true}
          />
        )
      default:
        return null
    }
  }
  const pushNewProductionPlan = () => {
    const dispatchObj = {
      type: 'GO_TO_CREATE_PRODUCTION_PLAN',
      payload: {
        company_id,
        detailView: {
          title: 'New Production Plan',
          previous: state.detailView.title
        }
      }
    }
    trackEvent('add_production_plan_clicked', { companyId: company_id })
    dispatch(dispatchObj)
  }

  let productPlanButton = null
  switch (companyInfo?.company_type) {
    case 'syngenta':
    case 'grain-receiver':
    case '3PO':
      if (hasAccess(company_id, 'create-production-plan') === 'SUCCESS') {
        productPlanButton = (
          <Button styleType="success" onClick={pushNewProductionPlan}>
            Add production plan
          </Button>
        )
      }
      break
    default:
      break
  }

  const buttons = (
    <div className='df'>
      {isSyncCompany && companyInfo?.sap_id !== 'N/A' &&
          <div className='mr10'>
            <Button
              text={synBtnTxt}
              clickHandler={handleSyncCompany}
              disabled={synBtnTxt !== 'Sync company'}
            />
          </div>
      }
      {productPlanButton}
    </div>
  )

  const getMoreContracts = () => {

    if(contractDataOffset !== null && allContractData.length > 0) {
      let offset = contract_data_limit * (contractDataOffset+1) + 0
      setContractDataOffset(contractDataOffset+1)
      let concatVal  = [...allContractData]
      setIsLoadExtraData(true)
      getCompanyContractsByYear(company_id, contract_data_limit, contractYear, offset, statusArr)
      .then(res => {
        if(res.length > 0 ) {
          concatVal=[...concatVal,...res]
          setAllContractData(concatVal)
          setIsLoadExtraData(false)
        }else{
          setContractDataOffset(null)
          setIsLoadExtraData(false)
        }
      })
      .catch(error => {
        setContractDataOffset(null)
        setIsLoadExtraData(false)
      })

    }
  }

  return (
    <DetailView button={buttons} companyPage='true'>
      <>
        <EmployeesWidget
          handleModal={handleModalEmployees}
          data={employeeData}
          status={employeeStatus}
          handleClose={handleClose}
          customSort={customSort}
        />
        <LinkedCompanies
          company_id={company_id}
          _getLinkCompanies={_getLinkCompanies}
          data={linkCompanyData}
          status={linkCompanyStatus}
          parentCompanyName={state.detailView?.title}
          customSort={customSort}
        />
        <LinkedContactsWidget
          handleModal={handleModalLinkedContacts}
          data={linkedContactsData}
          status={linkedContactsStatus}
          handleClose={handleClose}
          customSort={customSort}
        />
        <ContractTable
          setStatusArr={setStatusArr}

          filterHandler={year => setContractYear(year)}
          contractYear={contractYear}
          customSort={customSort}
          setSortOrder={setSortOrder}
          setSortByKey={setSortByKey}
          data={filterContractData}
          history={props.history}
          showCreateContract={showCreateContract}
          status={contractStatus}
          companyId={SAPId ? SAPId : company_id}
          companyType={companyInfo?.company_type}
          displayCreatedDate={false}
          filterByStatus={true}
          hideContractYear={true}
          onScrollAPI={getMoreContracts}
          isLoadExtraData={isLoadExtraData}
        />
        {((companyInfo?.company_type === 'grain-receiver' || companyInfo?.company_type === '3PO') && !(companyInfo?.company_type === 'grain-receiver' && companyInfo?.inventory_code === "SYN1"))?
          <ScaleTicketsTable
            filterHandler={year => setScaleTicketsYear(year)}
            scaleTicketsProdPlan={scaleTicketSpecificProdPlan}
            data={scaleTicketsData}
            history={props.history}
            status={scaleTicketsStatus}
            scaleTicketsYear={scaleTicketsYear}
            companyId={SAPId ? SAPId : company_id}
            handleDelete={handleDelete}
            fetchScaleTickets={fetchScaleTickets}
            setFetchScaleTickets={setFetchScaleTickets}
            contractYear={contractYear}
            customSort={customSort}
          />
          :
          null
        }
        {prodPlanData?.length ? (
          <ViewProdPlanDeliveryWidget
            aph={aphvalue}
            filterHandler={year => setProductionPlanYear(year)}
            contractType={
              yearSpecificProdPlan?.production_plan_extra?.contract_type_enum
            }
            monthlyUnits={monthlyUnits}
            totalReceived={totalReceived}
            unitType={yearSpecificProdPlan?.unit_type}
            premium_type={yearSpecificProdPlan?.premium_type}
            prodPlanYear={productionPlanYear}
            initialAcres={yearSpecificProdPlan?.total_acres}
            initialUnits={yearSpecificProdPlan?.total_units}
            status={deliveryStatus}
            grainReceivers={true}
            prodPlanData={prodPlanData}
            companyId={SAPId ? SAPId : company_id}
          />
        ) : null}
        {prodPlanData?.length ? (
          <ProductionPlansWidget
            data={prodPlanData}
            status={prodPlanStatus}
            company_id={company_id}
          />
        ) : null}
        <Modal
          autoHeight
          show={showModal}
          handleClose={handleClose}
          handleCloseToast={() => setShowToast(false)}
        >
          {renderModal()}
        </Modal>
        {showModal === false && showToast === true ? <Toast /> : null}
        {showAlert ? (
          <Alert
            alertMessage='User with this email address does not exist. Please select "New User" or check email for spelling'
            handleDismiss={() => setShowAlert(false)}
          />
        ) : null}
      </>
      <>
        <CompanyInformation
          patchHandler={patchHandler}
          companyInfo={companyInfo}
          handleModal={handleResellerModal}
          companyID={company_id}
        />
        <DetailComponent
          patchHandler={patchHandler}
          detailData={detailData}
          handleModal={handleCompanyDetailsModal}
          companyID={company_id}
          get_company={get_company}
          handleClose={handleClose}
          contractYear={contractYear}
          SAPId = {SAPId}
          companyInfo={companyInfo}
          prodPlanData={prodPlanData}
        />
      </>
    </DetailView>
  )
}

export default CompanyDetailView
